import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { EventApplicationService } from "../../../../services";
import { ApplicationType } from "../../../../constants/Enum";
import { EventService, GlobalSettingService } from "../../../../services";
import { GlobalConstant } from "../../../../constants";
import {
  formatAmount,
  handleConsoleError,
} from "../../../../utils/common-methods";
import { toast } from "react-toastify";

const CaterUnits = () => {
  const {
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext();

  const { eventId, unitId } = useParams();
  const [currentUnitId, setCurrentUnitId] = useState();
  const [isbackUPVehicle, setbackUPVehicle] = useState(false);
  const eventApplicationCatersId = getValues("caterApplicationFormData.id");
  const amount = getValues("applicableFee");

  const appType = getValues("appType");

  const currentBidAmount = getValues("currentBidAmount");
  const [expandedUnits, setExpandedUnits] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [eventUnits, setEventUnits] = useState([]);
  const [electricalTotal, setElectricalTotal] = useState(0);
  const [bohElectricalTotal, setbohElectricalTotal] = useState(0);
  const [bvElectricalTotal, setbvElectricalTotal] = useState(0);
  const getKeyValueByKeyName = (keyName) => {
    const entry = getValues("retailApplicationFormData.globalSettings")?.find(
      (item) => item.keyName === keyName
    );
    return entry ? entry.keyValue : null;
  };

  const showBidAmount = (unit) => {
    if (appType === ApplicationType.Fixed) {
      return (
        <label style={{ marginBottom: "0px" }}>
          <strong>Price £{formatAmount(unit?.amount)}</strong>
        </label>
      );
    }
    if (appType === ApplicationType.Turnover) {
      return (
        <label style={{ marginBottom: "0px" }}>
          <strong>Commitment Fee £{formatAmount(unit?.turnOverAmount)}</strong>
        </label>
      );
    }
    if (appType === ApplicationType.Tender) {
      return (
        <label style={{ marginBottom: "0px" }}>
          <strong>
            Minimum Starting Bid £{formatAmount(unit?.baseAmount)}
          </strong>{" "}
        </label>
      );
    }
    if (appType === ApplicationType.Bid) {
      return (
        <label style={{ marginBottom: "0px" }}>
          <strong>
            Minimum Bid £{formatAmount(unit?.currentBidAmount || unit?.amount)}
          </strong>
        </label>
      );
    }
  };
  const getMinAmount = (unit) => {
    if (appType === ApplicationType.Tender) {
      return formatAmount(unit?.baseAmount);
    }

    if (appType === ApplicationType.Bid) {
      return formatAmount(unit?.currentBidAmount || unit?.amount);
    }
  };

  const handlebackUPVehicle = (event) => {
    setValue("unit.backUPVehicle", event.target.checked ? true : false);
    setbackUPVehicle(event.target.checked ? true : false);
    if (event.target.checked) {
      setValue("unit.backUPVehicleType", null);
      setValue("unit.bvConn1x16SingleQty", null);
      setValue("unit.bvConn1x32SingleQty", null);
    }
  };

  const getPrice = (unit, matchingunit) => {
    if (
      appType === ApplicationType.Fixed ||
      appType === ApplicationType.Turnover
    ) {
      return unit.amount;
    }
    if (appType === ApplicationType.Tender) {
      return matchingunit?.pitchPrice || unit?.amount;
    }
    if (appType === ApplicationType.Bid) {
      return unit?.currentBidAmount || unit?.amount;
    }
  };

  const getRetailCostingDetails = async () => {
    try {
      const response = await GlobalSettingService.getEventGlobalSettingList(
        eventId
      );

      if (response?.isSuccess && response?.data.length > 0) {
        setValue(
          "retailApplicationFormData.globalSettings",
          response?.data || []
        );
        const initialAMP_16_PRICE = getValues(
          "retailApplicationFormData.AMP_16_PRICE"
        );

        const initialAMP_32_PRICE = getValues(
          "retailApplicationFormData.AMP_32_PRICE"
        );
        // setValue(
        //   "retailApplicationFormData.vat",
        //   getKeyValueByKeyName(GlobalConstant.VAT_PERCENT)
        // );

        setValue("retailApplicationFormData.AMP_16_PRICE", initialAMP_16_PRICE);
        setValue("retailApplicationFormData.AMP_32_PRICE", initialAMP_32_PRICE);
      }
      const res = await EventService.getUnitById(unitId);
      if (res && res?.data) {
        const activeUnits = [res?.data]; //.filter((unit) => unit.isActive);
        activeUnits.forEach((unit) => {
          // unit.currentBidAmount = unit.amount;
          unit.baseAmount = unit?.amount;
          unit.currentBidAmount = currentBidAmount
            ? currentBidAmount
            : unit?.amount;
          unit.turnOverAmount = unit?.amount;
          unit.unitId = unit?.id;
        });
        setEventUnits(activeUnits);
        activeUnits.map((p) => setValue("unit", p));
        const resUnit = await EventApplicationService.getCaterApplicationById(
          eventApplicationCatersId
        );
        let initialSelectedUnits = [];
        setElectricalTotal(0);
        setbohElectricalTotal(0);
        setbvElectricalTotal(0);
        if (resUnit.isSuccess) {
          setValue("unit.currentBidAmount", resUnit?.data?.currentBidAmount);
          initialSelectedUnits = resUnit.data.objEventApplicationCateresDetailsViewModel.map(
            (item) => {
              setbackUPVehicle(item.backUPVehicle);
              setCurrentUnitId(item.id);
              const unitOld = getValues("unit");
              unitOld.eventApplicationCatersId = eventApplicationCatersId;
              delete unitOld.id;
              if (
                appType !== ApplicationType.Turnover &&
                appType !== ApplicationType.Fixed
              ) {
                unitOld.amount = item?.amount;
              } else {
                unitOld.amount = unitOld?.baseAmount;
              }

              setValue("unit", {
                ...unitOld,
                ...item,
                amount: unitOld?.amount,
              });
              return item;
            }
          );

          setEventUnits([{ ...eventUnits, ...getValues("unit") }]);
          if (initialSelectedUnits.length > 0) {
            let amp16 = getKeyValueByKeyName(GlobalConstant.AMP_16_PRICE);
            let amp32 = getKeyValueByKeyName(GlobalConstant.AMP_32_PRICE);

            const electricalTotalTmp =
              initialSelectedUnits[0]?.conn1x16SingleQty * amp16 +
              initialSelectedUnits[0]?.conn1x32SingleQty * amp32;
            setElectricalTotal(electricalTotalTmp);

            const bohelectricalTotaltmp =
              initialSelectedUnits[0]?.bohConn1x16SingleQty * amp16 +
              initialSelectedUnits[0]?.bohConn1x32SingleQty * amp32;
            setbohElectricalTotal(bohelectricalTotaltmp);

            const bvelectricalTotalTmp =
              initialSelectedUnits[0]?.bvConn1x16SingleQty * amp16 +
              initialSelectedUnits[0]?.bvConn1x32SingleQty * amp32;
            setbvElectricalTotal(bvelectricalTotalTmp);
          }
        }

        const populatedUnits = activeUnits.filter((unit) =>
          initialSelectedUnits.some((selected) => selected.unitId === unit.id)
        );

        populatedUnits.forEach((unit) => {
          const matchingunit = initialSelectedUnits.find(
            (p) => p.unitId === unit?.id
          );

          if (matchingunit) {
            matchingunit.pitchPrice = matchingunit?.amount;
            unit.unitQty = matchingunit?.unitQty || 0;
            const updatedAmount = getPrice(unit, matchingunit);

            unit.amount = updatedAmount;
          }
        });

        const updatedunit = populatedUnits
          .filter((p) => p.unitQty > 0)
          .map((p) => ({
            unitId: p.id,
            unitPrice: p.amount,
            unitQty: p.unitQty,
            amount: p.amount,
          }));
        setValue("caterApplicationFormData.selectedUnits", populatedUnits);
        setValue("unit.eventApplicationCatersId", eventApplicationCatersId);
        setValue(
          "caterApplicationFormData.objEventApplicationCateresDetailsViewModel",
          updatedunit
        );
      }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  useEffect(() => {
    getRetailCostingDetails();
  }, []);

  const handleDropdownToggle = () => {
    setIsOpen(!isOpen);
  };
  const toggleDescription = (unitId) => {
    setExpandedUnits((prevState) => ({
      ...prevState,
      [unitId]: !prevState[unitId],
    }));
  };

  const renderUnitDescription = (unit) => {
    const isExpanded = expandedUnits[unit?.id];
    const maxLength = 190;
    const description = unit?.description || "";
    const truncatedDescription =
      description.length > maxLength && !isExpanded
        ? `${description.substring(0, maxLength)}...`
        : description;

    return (
      <div style={{ marginTop: "8px" }}>
        <h3>Description</h3>
        <p
          dangerouslySetInnerHTML={{
            __html: truncatedDescription,
          }}
        ></p>
        {description.length > maxLength && (
          <a
            href="#!"
            onClick={(e) => {
              e.preventDefault();
              toggleDescription(unit?.id);
            }}
            className="toggle-text"
          >
            {isExpanded ? "Show Less" : "Show More"}
          </a>
        )}
      </div>
    );
  };
  const handleDropdownChange = (e, unit) => {
    const quantity = parseInt(e.target.value, 10);
    const updatedUnits = eventUnits.map((p) =>
      p.id === unit.id ? { ...p, unitQty: quantity } : p
    );

    setEventUnits(updatedUnits);
    const selectedUnits = updatedUnits
      .filter((p) => p.unitQty > 0)
      .map((p) => ({
        unitId: p.id,
        unitPrice: p.amount,
        unitQty: p.unitQty,
        amount: p.amount,
      }));
    const selectedUnit = selectedUnits[0];
    if (selectedUnit) {
      const uniOld = getValues("unit");
      setValue("unit", {
        ...uniOld,
        unitQty: selectedUnit?.unitQty,
        unitPrice: selectedUnit?.amount,
        amount: selectedUnit?.amount,
      });
    }

    setValue("caterApplicationFormData.selectedUnits", selectedUnits);
    setValue(
      "caterApplicationFormData.objEventApplicationCateresDetailsViewModel",
      selectedUnits
    );
    setValue("unit.id", currentUnitId);
    setValue("unit.eventApplicationCatersId", eventApplicationCatersId);
  };

  const handleBidChange = (e, unit) => {
    const value = e.target.value;
    if (!isNaN(value) && value !== "") {
      const amount = parseInt(value);

      const updatedUnits = eventUnits.map((p) =>
        p.id === unit.id ? { ...p, amount: amount } : p
      );
      setEventUnits(updatedUnits);
      const selectedUnits = updatedUnits
        .filter((p) => p.unitQty > 0)
        .map((p) => ({
          unitId: p.id,
          unitPrice: p.amount,
          unitQty: p.unitQty,
          amount: p.amount,
        }));
      const selectedUnit = selectedUnits[0];

      if (selectedUnit) {
        const uniOld = getValues("unit");
        setValue("unit", {
          ...uniOld,
          unitQty: selectedUnit?.unitQty,
          unitPrice: selectedUnit?.amount,
          amount: selectedUnit?.amount,
        });
      }

      setValue("caterApplicationFormData.selectedUnits", selectedUnits);
      setValue(
        "caterApplicationFormData.objEventApplicationCateresDetailsViewModel",
        selectedUnits
      );
      // trigger("unit.amount");
      //trigger("caterApplicationFormData.selectedUnits");
    } else {
      //setEventUnits([{ ...eventUnits }, { amount: "0" }]);
      const updatedUnits = eventUnits.map((p) =>
        p.id === unit.id ? { ...p, amount: 0 } : p
      );
      setEventUnits(updatedUnits);
    }
  };

  const calculateTotalForUnit = (unit) => {
    const quantity = unit.unitQty || 0;
    const amount = (unit.amount ?? 0) * quantity;
    if (!isNaN(amount)) {
      return formatAmount(amount);
    } else {
      return formatAmount(0);
    }
  };

  const handleConn1x16Single = (e) => {
    let amp16 = getKeyValueByKeyName(GlobalConstant.AMP_16_PRICE);
    let amp32 = getKeyValueByKeyName(GlobalConstant.AMP_32_PRICE);
    const electricalTotalTmp =
      amp16 * e.target.value + amp32 * getValues("unit.conn1x32SingleQty");
    //setElectricalTotal(electricalTotalTmp);
    if (!isNaN(electricalTotalTmp)) {
      setElectricalTotal(electricalTotalTmp);
    } else {
      setElectricalTotal(0);
    }
  };

  const handleConn1x32Single = (e) => {
    let amp16 = getKeyValueByKeyName(GlobalConstant.AMP_16_PRICE);
    let amp32 = getKeyValueByKeyName(GlobalConstant.AMP_32_PRICE);
    const electricalTotalTmp =
      amp16 * getValues("unit.conn1x16SingleQty") + amp32 * e.target.value;
    // setElectricalTotal(electricalTotalTmp);
    if (!isNaN(electricalTotalTmp)) {
      setElectricalTotal(electricalTotalTmp);
    } else {
      setElectricalTotal(0);
    }
  };

  const handlebohConn1x16Single = (e) => {
    let amp16 = getKeyValueByKeyName(GlobalConstant.AMP_16_PRICE);
    let amp32 = getKeyValueByKeyName(GlobalConstant.AMP_32_PRICE);
    const bohElectricalTotalTmp =
      amp16 * e.target.value + amp32 * getValues("unit.bohConn1x32SingleQty");
    if (!isNaN(bohElectricalTotalTmp)) {
      setbohElectricalTotal(bohElectricalTotalTmp);
    } else {
      setbohElectricalTotal(0);
    }
  };

  const handlebohConn1x32Single = (e) => {
    let amp16 = getKeyValueByKeyName(GlobalConstant.AMP_16_PRICE);
    let amp32 = getKeyValueByKeyName(GlobalConstant.AMP_32_PRICE);
    const bohElectricalTotalTmp =
      amp16 * getValues("unit.bohConn1x16SingleQty") + amp32 * e.target.value;
    // setbohElectricalTotal(bohElectricalTotalTmp);
    if (!isNaN(bohElectricalTotalTmp)) {
      setbohElectricalTotal(bohElectricalTotalTmp);
    } else {
      setbohElectricalTotal(0);
    }
  };

  const handlebvConn1x16Single = (e) => {
    let amp16 = getKeyValueByKeyName(GlobalConstant.AMP_16_PRICE);
    let amp32 = getKeyValueByKeyName(GlobalConstant.AMP_32_PRICE);
    const bvElectricTotalTmp =
      amp16 * e.target.value + amp32 * getValues("unit.bvConn1x32SingleQty");
    // setbvElectricalTotal(bvElectricTotalTmp);
    if (!isNaN(bvElectricTotalTmp)) {
      setbvElectricalTotal(bvElectricTotalTmp);
    } else {
      setbvElectricalTotal(0);
    }
  };

  const handlebvConn1x32Single = (e) => {
    let amp16 = getKeyValueByKeyName(GlobalConstant.AMP_16_PRICE);
    let amp32 = getKeyValueByKeyName(GlobalConstant.AMP_32_PRICE);
    const bvElectricTotalTmp =
      amp16 * getValues("unit.bvConn1x16SingleQty") + amp32 * e.target.value;
    // setbvElectricalTotal(bvElectricTotalTmp);
    if (!isNaN(bvElectricTotalTmp)) {
      setbvElectricalTotal(bvElectricTotalTmp);
    } else {
      setbvElectricalTotal(0);
    }
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-lg-12">
          <div className="trader-booking-f">
            <h3>Pitch Details</h3>

            {eventUnits.map((unit) => (
              <div key={unit.id}>
                <React.Fragment>
                  <div className="row pitch-react1">
                    <div
                      className="col-sm-12 col-md-3 col-lg-3"
                      style={{ marginTop: "8px" }}
                    >
                      <div className="calcuater2">
                        {"Facility Fee"} {"(" + unit?.unitTitle + ")"}
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-7 col-lg-7">
                      <div className="count-pitch" style={{ marginTop: "8px" }}>
                        {showBidAmount(unit)}

                        <div>
                          <label
                            style={{ marginBottom: "0px" }}
                            htmlFor="dropdown"
                          >
                            Pitch Quantity:
                          </label>{" "}
                          <select
                            name={`caterApplicationFormData.selectedUnits[${unit?.id}].unitQty`}
                            value={unit?.unitQty || 0}
                            onChange={(e) => handleDropdownChange(e, unit)}
                            onClick={handleDropdownToggle} // Toggle the dropdown open/close
                          >
                            {[...Array(unit?.maxAllowed + 1).keys()].map(
                              (num) => (
                                <option key={num} defaultValue={num}>
                                  {num}
                                </option>
                              )
                            )}
                          </select>
                        </div>

                        {(appType === ApplicationType.Bid ||
                          appType === ApplicationType.Tender) && (
                          <React.Fragment>
                            add your maximum bid amount:
                            <Form.Control
                              className="effect-4 bid-100"
                              maxLength={5}
                              type="text"
                              {...register(unit.id, {
                                pattern: {
                                  value: /^[+]?[0-9]*\.?[0-9]+$/,
                                  message:
                                    " Please enter a valid number greater than zero.",
                                },

                                validate: (value) =>
                                  parseFloat(value) >
                                    parseFloat(getMinAmount(unit)) ||
                                  " Value must be greater than £" +
                                    getMinAmount(unit),
                              })}
                              onChange={(e) => handleBidChange(e, unit)}
                              // value={unit.amount}
                              defaultValue={unit?.amount}
                            />
                          </React.Fragment>
                        )}
                      </div>
                      {unit.description && renderUnitDescription(unit)}
                      <div style={{ marginTop: "8px" }}>
                        Maximum Individual Applications Allowed :{" "}
                        {unit?.maxAllowed}
                      </div>
                      <div style={{ marginTop: "8px" }}>
                        {unit.refundable ? "Refundable" : "Non-Refundable"}
                      </div>
                      <div style={{ marginTop: "8px" }}>
                        {errors[unit.id] && (
                          <span className="text-danger">
                            {errors[unit.id]?.message}
                          </span>
                        )}
                      </div>
                      <div style={{ marginTop: "8px" }}>
                        {errors.caterApplicationFormData?.selectedUnits && (
                          <span className="text-danger">
                            {
                              errors.caterApplicationFormData.selectedUnits?.message
                            }
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-2 col-lg-2">
                      <div className="calcuater1">
                        <strong>£ {calculateTotalForUnit(unit)}</strong>
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{ paddingTop: "15px" }}>
                    <div className="col-sm-12 col-md-3 col-lg-3">
                      <h3>Unit Dimensions :</h3>
                      {/* <div>
                        <span>1x16 Single </span>£{" "}
                        {formatAmount(
                          getKeyValueByKeyName(GlobalConstant.AMP_16_PRICE)
                        )}
                      </div>
                      <div>
                        <span>1x32 Single </span>£{" "}
                        {formatAmount(
                          getKeyValueByKeyName(GlobalConstant.AMP_32_PRICE)
                        )}
                      </div> */}
                    </div>
                    <div className="col-sm-12 col-md-7 col-lg-7">
                      <div>
                        <div>
                          <Form.Group controlId="unitLength" className="mb-3">
                            <Form.Label>
                              Unit Length (frontage) (meters)
                            </Form.Label>
                            <Form.Control
                              className="effect-4"
                              maxLength={15}
                              type="text"
                              {...register("unit.unitLength", {
                                required: "Please enter unit length",
                                pattern: {
                                  value: /^[+]?[0-9]*\.?[0-9]+$/,
                                  message:
                                    "Please enter a valid number greater than zero.",
                                },
                              })}
                            />
                            <span className="focus-border"></span>
                          </Form.Group>
                        </div>
                        {errors.unit?.unitLength && (
                          <span className="text-danger">
                            {errors.unit?.unitLength?.message}
                          </span>
                        )}
                      </div>
                      <div>
                        <div>
                          <Form.Group controlId="unitWidth" className="mb-3">
                            <Form.Label>Unit Width (depth) (meters)</Form.Label>
                            <Form.Control
                              className="effect-4"
                              maxLength={15}
                              type="text"
                              {...register("unit.unitWidth", {
                                required: "Please enter unit width",
                                pattern: {
                                  value: /^[+]?[0-9]*\.?[0-9]+$/,
                                  message:
                                    "Please enter a valid number greater than zero.",
                                },
                              })}
                              //defaultValue={unitData.unitLenght}
                            />
                            <span className="focus-border"></span>
                          </Form.Group>
                        </div>
                        {errors.unit?.unitWidth && (
                          <span className="text-danger">
                            {errors.unit?.unitWidth?.message}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-2 col-lg-2">
                      <div className="calcuater1">
                        {/* <strong>£ {formatAmount(electricalTotal)}</strong> */}
                      </div>
                    </div>
                  </div>
                  <div
                    className="row pitch-react1"
                    style={{ paddingTop: "15px" }}
                  >
                    <div className="col-sm-12 col-md-3 col-lg-3">
                      <h3>Electrical Connection :</h3>
                      (pitch)
                      <div>
                        <span>1x16 Single </span>£{" "}
                        {formatAmount(
                          getKeyValueByKeyName(GlobalConstant.AMP_16_PRICE)
                        )}
                      </div>
                      <div>
                        <span>1x32 Single </span>£{" "}
                        {formatAmount(
                          getKeyValueByKeyName(GlobalConstant.AMP_32_PRICE)
                        )}
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-7 col-lg-7">
                      <p
                        style={{
                          color: "red",
                          textDecoration: "underline",
                          fontWeight: "bold",
                        }}
                      >
                        PERSONAL GENERATORS ARE NOT PERMITTED AT THIS EVENT
                      </p>
                      <p>
                        Power is charged on a single connection basis per unit.
                        If you require additional power above a single
                        connection for your unit(s) please indicate the required
                        number of connections below. Power audits will be
                        conducted continuously throughout the event and anyone
                        caught using more power than ordered will be asked to
                        leave the event.
                      </p>
                      <div>
                        <div>
                          <Form.Group
                            controlId="conn1x16SingleQty"
                            className="mb-3"
                          >
                            <Form.Label>Connection 1x16 Single Qty</Form.Label>
                            <Form.Control
                              className="effect-4"
                              maxLength={15}
                              type="text"
                              {...register("unit.conn1x16SingleQty", {
                                pattern: {
                                  value: /^[+]?[0-9]*\.?[0-9]+$/,
                                  message:
                                    "Please enter a valid number greater than zero.",
                                },
                              })}
                              defaultValue={unit?.conn1x16SingleQty}
                              onChange={handleConn1x16Single}
                            />
                            <span className="focus-border"></span>
                          </Form.Group>
                        </div>
                        {errors.unit?.conn1x16SingleQty && (
                          <span className="text-danger">
                            {errors.unit?.conn1x16SingleQty?.message}
                          </span>
                        )}
                      </div>
                      <div>
                        <div>
                          <Form.Group
                            controlId="conn1x32SingleQty"
                            className="mb-3"
                          >
                            <Form.Label>Connection 1x32 Single Qty</Form.Label>
                            <Form.Control
                              className="effect-4"
                              maxLength={15}
                              type="text"
                              {...register("unit.conn1x32SingleQty", {
                                pattern: {
                                  value: /^[+]?[0-9]*\.?[0-9]+$/,
                                  message:
                                    "Please enter a valid number greater than zero.",
                                },
                              })}
                              defaultValue={unit?.conn1x32SingleQty}
                              onChange={handleConn1x32Single}
                            />
                            <span className="focus-border"></span>
                          </Form.Group>
                        </div>
                        {errors.unit?.conn1x32SingleQty && (
                          <span className="text-danger">
                            {errors.unit?.conn1x32SingleQty?.message}
                          </span>
                        )}
                      </div>

                      <p>
                        You must provide at least a 20m lead to connect your
                        unit to the power supply.
                      </p>
                      <p>
                        If additional electricity is required when onsite this
                        will be provided but there will be a £60 charge plus the
                        uplift - this will be payable immediately. Power
                        connection timings will be advised closer to the event.
                      </p>
                    </div>

                    <div className="col-sm-12 col-md-2 col-lg-2">
                      <div className="calcuater1">
                        <strong>£ {formatAmount(electricalTotal)}</strong>
                      </div>
                    </div>
                  </div>
                  <React.Fragment>
                    <Form.Group controlId="unitId">
                      <Form.Control
                        type="hidden"
                        {...register("caterApplicationFormData.selectedUnits", {
                          validate: (value) =>
                            value?.length > 0 ||
                            "Please select at least one pitch",
                        })}
                      />
                    </Form.Group>
                    {/* register("caterApplicationFormData.selectedUnits", {
      validate: (value) =>
        value?.length > 0 || "Please select at least one pitch",
    }); */}
                    <Form.Group controlId="unitId">
                      <Form.Control type="hidden" {...register("unit.id")} />
                    </Form.Group>
                    <Form.Group controlId="unitId">
                      <Form.Control
                        type="hidden"
                        {...register("unit.unitId")}
                        defaultValue={unit?.unitId}
                      />
                    </Form.Group>
                    <Form.Group controlId="unit.Qty">
                      <Form.Control
                        type="hidden"
                        {...register("unit.unitQty")}
                        defaultValue={unit?.unitQty}
                      />
                    </Form.Group>
                    <Form.Group controlId="caterApplicationFormData">
                      <Form.Control
                        type="hidden"
                        {...register("caterApplicationFormData.id")}
                      />
                    </Form.Group>

                    <Form.Group controlId="eventApplicationCatersId">
                      <Form.Control
                        type="hidden"
                        {...register("unit.eventApplicationCatersId")}
                        defaultValue={eventApplicationCatersId}
                      />
                    </Form.Group>
                    <Form.Group controlId="unit.amount">
                      <Form.Control
                        type="hidden"
                        {...register("unit.amount")}
                        defaultValue={amount}
                      />
                    </Form.Group>
                  </React.Fragment>

                  <React.Fragment>
                    {/* <h2
                      className="retail-form-hd1"
                      style={{ marginTop: "25px" }}
                    >
                      Additional Costings
                    </h2> */}
                    <div className="row" style={{ paddingTop: "15px" }}>
                      <div className="col-sm-12 col-md-3 col-lg-3">
                        <h3>Back Of House :</h3>
                      </div>

                      <div className="col-sm-12 col-md-7 col-lg-7">
                        <div>
                          <div>
                            <Form.Group controlId="bohLength" className="mb-3">
                              <Form.Label>
                                Back Of House Length (meters)
                              </Form.Label>
                              <Form.Control
                                className="effect-4"
                                maxLength={15}
                                type="text"
                                {...register("unit.bohLength", {
                                  pattern: {
                                    value: /^[+]?[0-9]*\.?[0-9]+$/,
                                    message:
                                      "Please enter a valid number greater than zero.",
                                  },
                                })}
                                defaultValue={unit?.bohLength}
                              />
                              <span className="focus-border"></span>
                            </Form.Group>
                          </div>
                          {errors.unit?.bohLength && (
                            <span className="text-danger">
                              {errors.unit?.bohLength?.message}
                            </span>
                          )}
                          <div>
                            <div>
                              <Form.Group controlId="bohWidth" className="mb-3">
                                <Form.Label>
                                  Back Of House Width (meters)
                                </Form.Label>
                                <Form.Control
                                  className="effect-4"
                                  maxLength={15}
                                  type="text"
                                  {...register("unit.bohWidth", {
                                    pattern: {
                                      value: /^[+]?[0-9]*\.?[0-9]+$/,
                                      message:
                                        "Please enter a valid number greater than zero.",
                                    },
                                  })}
                                  defaultValue={unit?.bohWidth}
                                />
                                <span className="focus-border"></span>
                              </Form.Group>
                            </div>
                            {errors.unit?.bohWidth && (
                              <span className="text-danger">
                                {errors.unit?.bohWidth?.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="row pitch-react1"
                      style={{ paddingTop: "15px" }}
                    >
                      <div className="col-sm-12 col-md-3 col-lg-3">
                        <h3>Electrical Connection:</h3>
                        (back of house)
                        <div>
                          <span>1x16 Single </span>£{" "}
                          {formatAmount(
                            getKeyValueByKeyName(GlobalConstant.AMP_16_PRICE)
                          )}
                        </div>
                        <div>
                          <span>1x32 Single </span>£{" "}
                          {formatAmount(
                            getKeyValueByKeyName(GlobalConstant.AMP_32_PRICE)
                          )}
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-7 col-lg-7">
                        <p
                          style={{
                            color: "red",
                            textDecoration: "underline",
                            fontWeight: "bold",
                          }}
                        >
                          PERSONAL GENERATORS ARE NOT PERMITTED AT THIS EVENT
                        </p>
                        <p>
                          Power is charged on a single connection basis per
                          unit. If you require additional power above a single
                          connection for your unit(s) please indicate the
                          required number of connections below. Power audits
                          will be conducted continuously throughout the event
                          and anyone caught using more power than ordered will
                          be asked to leave the event.
                        </p>
                        <div>
                          <div>
                            <Form.Group
                              controlId="bohConn1x16SingleQty"
                              className="mb-3"
                            >
                              <Form.Label>
                                Connection 1x16 Single Qty
                              </Form.Label>
                              <Form.Control
                                className="effect-4"
                                maxLength={15}
                                type="text"
                                {...register("unit.bohConn1x16SingleQty", {
                                  pattern: {
                                    value: /^[+]?[0-9]*\.?[0-9]+$/,
                                    message:
                                      "Please enter a valid number greater than zero.",
                                  },
                                })}
                                defaultValue={unit?.bohConn1x16SingleQty}
                                onChange={handlebohConn1x16Single}
                              />
                              <span className="focus-border"></span>
                            </Form.Group>
                          </div>
                          {errors.unit?.bohConn1x16SingleQty && (
                            <span className="text-danger">
                              {errors.unit?.bohConn1x16SingleQty?.message}
                            </span>
                          )}
                        </div>
                        <div>
                          <div>
                            <Form.Group
                              controlId="bohConn1x32SingleQty"
                              className="mb-3"
                            >
                              <Form.Label>
                                Connection 1x32 Single Qty
                              </Form.Label>
                              <Form.Control
                                className="effect-4"
                                maxLength={15}
                                type="text"
                                {...register("unit.bohConn1x32SingleQty", {
                                  pattern: {
                                    value: /^[+]?[0-9]*\.?[0-9]+$/,
                                    message:
                                      "Please enter a valid number greater than zero.",
                                  },
                                })}
                                defaultValue={unit?.bohConn1x32SingleQty}
                                onChange={handlebohConn1x32Single}
                              />
                              <span className="focus-border"></span>
                            </Form.Group>
                          </div>
                          {errors.unit?.bohConn1x32SingleQty && (
                            <span className="text-danger">
                              {errors.unit?.bohConn1x32SingleQty?.message}
                            </span>
                          )}
                        </div>
                        <p>
                          You must provide at least a 20m lead to connect your
                          unit to the power supply.
                        </p>
                        <p>
                          If additional electricity is required when onsite this
                          will be provided but there will be a £60 charge plus
                          the uplift - this will be payable immediately. Power
                          connection timings will be advised closer to the
                          event.
                        </p>
                      </div>

                      <div className="col-sm-12 col-md-2 col-lg-2">
                        <div className="calcuater1">
                          <strong>£ {formatAmount(bohElectricalTotal)}</strong>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                  <div className="row" style={{ paddingTop: "15px" }}>
                    <div className="col-sm-12 col-md-3 col-lg-3">
                      <h3>Back Up Vehicle:</h3>
                    </div>

                    <div className="col-sm-12 col-md-7 col-lg-7">
                      <Form.Group controlId="backUPVehicle" className="mb-3">
                        <div className="custom-check">
                          <Form.Label>Is Back Up Vehicle Required</Form.Label>
                          <Form.Check
                            type="checkbox"
                            defaultValue={isbackUPVehicle}
                            {...register("unit.backUPVehicle", {
                              required: "",
                            })}
                            checked={isbackUPVehicle} // Controlled by state
                            onChange={handlebackUPVehicle} // Handle change event
                          />
                        </div>
                      </Form.Group>
                      <p>BACK UP VEHICLES (Important Please read)</p>
                      <p>
                        {" "}
                        Back up vehicles will only be permitted in certain
                        catering locations and only after approval from the
                        Event Operations Director. Please be considerate of
                        others as space will be tight and only bring the
                        necessary sized vehicle(s)
                      </p>{" "}
                      <p>
                        The Event Operations Director reserves the right to
                        remove any inappropriate architecture from site. All
                        monies pais will be forteited.
                      </p>
                    </div>
                  </div>

                  {isbackUPVehicle && (
                    <React.Fragment>
                      <div className="row">
                        <div className="col-sm-12 col-md-3 col-lg-3">
                          {/* <h3>Back Up Vehicle:</h3> */}
                        </div>

                        <div className="col-sm-12 col-md-7 col-lg-7">
                          <div>
                            <div>
                              <Form.Group
                                controlId="backUPVehicleType"
                                className="mb-3"
                              >
                                <Form.Label>Type of vehicle</Form.Label>
                                <Form.Control
                                  className="effect-4"
                                  maxLength={15}
                                  type="text"
                                  {...register("unit.backUPVehicleType", {
                                    // required: "Please enter back up vehicle type",
                                  })}
                                  defaultValue={unit?.backUPVehicleType}
                                />
                                <span className="focus-border"></span>
                              </Form.Group>
                            </div>
                            {errors.unit?.backUPVehicleType && (
                              <span className="text-danger">
                                {errors.unit?.backUPVehicleType?.message}
                              </span>
                            )}
                          </div>
                          {/* <div className="effect-pitchs1">
              <label style={{ marginRight: "5px" }} htmlFor="additionalpasses">
                Additional ground passes (£
                {getKeyValueByKeyName(
                  GlobalConstant.ADDITIONAL_PASSES_PRICE
                )}{" "}
                each){" "}
              </label>
              <input
                id="additionalpasses"
                className="effect-4"
                placeholder="Enter number of additional passes"
                type="number"
                {...register("retailApplicationFormData.additionalpasses")}
                defaultValue={getValues(
                  "retailApplicationFormData.additionalpasses"
                )}
                onKeyUp={() => calculateFurnitureTotal()}
              />
            </div> */}
                        </div>
                        {/* <div className="col-sm-12 col-md-2 col-lg-2">
            <div className="calcuater1">
              <strong>£ {furnitureTotal}</strong>
            </div>
          </div> */}
                      </div>

                      <div className="row" style={{ paddingTop: "15px" }}>
                        <div className="col-sm-12 col-md-3 col-lg-3">
                          <h3>Electrical Connection :</h3>
                          (backup vehicle)
                          <div>
                            <span>1x16 Single </span>£{" "}
                            {formatAmount(
                              getKeyValueByKeyName(GlobalConstant.AMP_16_PRICE)
                            )}
                          </div>
                          <div>
                            <span>1x32 Single </span>£{" "}
                            {formatAmount(
                              getKeyValueByKeyName(GlobalConstant.AMP_32_PRICE)
                            )}
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-7 col-lg-7">
                          <p
                            style={{
                              color: "red",
                              textDecoration: "underline",
                              fontWeight: "bold",
                            }}
                          >
                            PERSONAL GENERATORS ARE NOT PERMITTED AT THIS EVENT
                          </p>
                          <p>
                            Power is charged on a single connection basis per
                            unit. If you require additional power above a single
                            connection for your unit(s) please indicate the
                            required number of connections below. Power audits
                            will be conducted continuously throughout the event
                            and anyone caught using more power than ordered will
                            be asked to leave the event.
                          </p>
                          <div>
                            <div>
                              <Form.Group
                                controlId="bvConn1x16SingleQty"
                                className="mb-3"
                              >
                                <Form.Label>
                                  Connection 1x16 Single Qty
                                </Form.Label>
                                <Form.Control
                                  className="effect-4"
                                  maxLength={15}
                                  type="text"
                                  {...register("unit.bvConn1x16SingleQty", {
                                    pattern: {
                                      value: /^[+]?[0-9]*\.?[0-9]+$/,
                                      message:
                                        "Please enter a valid number greater than zero.",
                                    },
                                  })}
                                  onChange={handlebvConn1x16Single}
                                  defaultValue={unit?.bvConn1x16SingleQty}
                                />
                                <span className="focus-border"></span>
                              </Form.Group>
                            </div>
                            {errors.unit?.bvConn1x16SingleQty && (
                              <span className="text-danger">
                                {errors.unit?.bvConn1x16SingleQty?.message}
                              </span>
                            )}
                          </div>
                          <div>
                            <div>
                              <Form.Group
                                controlId="bvConn1x32SingleQty"
                                className="mb-3"
                              >
                                <Form.Label>
                                  Connection 1x32 Single Qty
                                </Form.Label>
                                <Form.Control
                                  className="effect-4"
                                  maxLength={15}
                                  type="text"
                                  {...register("unit.bvConn1x32SingleQty", {
                                    pattern: {
                                      value: /^[+]?[0-9]*\.?[0-9]+$/,
                                      message:
                                        "Please enter a valid number greater than zero.",
                                    },
                                  })}
                                  onChange={handlebvConn1x32Single}
                                  defaultValue={unit?.bvConn1x32SingleQty}
                                />
                                <span className="focus-border"></span>
                              </Form.Group>
                            </div>
                            {errors.unit?.bvConn1x32SingleQty && (
                              <span className="text-danger">
                                {errors.unit?.bvConn1x32SingleQty?.message}
                              </span>
                            )}
                          </div>
                          <p>
                            You must provide at least a 20m lead to connect your
                            unit to the power supply.
                          </p>
                          <p>
                            If additional electricity is required when onsite
                            this will be provided but there will be a £60 charge
                            plus the uplift - this will be payable immediately.
                            Power connection timings will be advised closer to
                            the event.
                          </p>
                        </div>

                        <div className="col-sm-12 col-md-2 col-lg-2">
                          <div className="calcuater1">
                            <strong>£ {formatAmount(bvElectricalTotal)}</strong>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                </React.Fragment>
              </div>
            ))}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CaterUnits;
